import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import * as StringUtils from '../../../utilities/stringUtils';

import { Combobox, Filter, Popover } from '@salesforce/design-system-react';

class AssetClassFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedAssetClass: undefined };
  }

  selectedAssetClass() {
    return this.props.filter.assetClass;
  }

  selectedAssetClassSelection() {
    const assetClass =
      this.state.selectedAssetClass || this.selectedAssetClass();
    return [this.optionForAssetClass(assetClass)];
  }

  selectedAssetClassPredicate() {
    const assetClass = this.selectedAssetClass();
    return assetClass || this.assetClassPlaceholder();
  }

  optionForAssetClass(assetClass) {
    if (assetClass && assetClass !== '(all)') {
      return { id: assetClass, value: assetClass, label: assetClass };
    }
    return { id: '(all)', value: '(all)', label: this.assetClassPlaceholder() };
  }

  assetClassPlaceholder() {
    const { formatMessage } = this.props.intl;
    return formatMessage({ id: 'components.ecs.assetFilter.allAssetClasses' });
  }

  assetClassOptions() {
    // Don't show child classes
    const options = this.props.assetTypes
      .filter(assetType => !assetType.parent_class_id)
      // sort by name of class
      .sort(StringUtils.sortByField('type', this.props.intl.locale))
      // convert to option
      .map(assetType => this.optionForAssetClass(assetType.type));

    // insert the option (all) option first
    options.unshift(this.optionForAssetClass());
    return options;
  }

  onChangeAssetClass() {
    const selection = this.selectedAssetClassSelection();
    const filter = {};
    if (selection.length && selection[0].value !== '(all)') {
      filter.assetClass = selection[0].value;
    } else {
      filter.assetClass = null;
    }
    this.setState({ selectedAssetClass: filter.assetClass });
    this.props.actions.updateAssetFilter(filter);
  }

  render() {
    const { formatMessage } = this.props.intl;
    const assetClassProperty = formatMessage({
      id: 'components.ecs.assetFilter.assetClass'
    });

    return (
      <Filter
        className="asset-class-filter"
        onChange={this.onChangeAssetClass.bind(this)}
        onRemove={() =>
          this.props.actions.updateAssetFilter({ assetClass: null })
        }
        property={assetClassProperty}
        predicate={this.selectedAssetClassPredicate()}
        isPermanent={!this.selectedAssetClass()}
        popover={<Popover classNameBody="filter-popover" />}
      >
        <Combobox
          events={{
            onSelect: (event, { selection }) => {
              if (selection && selection.length) {
                this.setState({
                  selectedAssetClass: selection[0].value
                });
              }
            }
          }}
          labels={{ label: assetClassProperty }}
          menuPosition="relative"
          options={this.assetClassOptions()}
          selection={this.selectedAssetClassSelection()}
          variant="readonly"
        />
      </Filter>
    );
  }
}

AssetClassFilter.propTypes = {
  assetTypes: PropTypes.array,
  actions: PropTypes.object,
  filter: PropTypes.object.isRequired,
  location: PropTypes.object
};

export default injectIntl(AssetClassFilter);
